import { useEffect, useState } from 'react';
import mapApi from '~/apis/map';
import type { IPersonStatus } from '~/utils/interface/map';

export function usePersonStatus(): IPersonStatus[] {
  const [personStatuses, setPersonStatuses] = useState<IPersonStatus[]>([]);

  useEffect(() => {
    mapApi
      .getPersonStatus()
      .then((res) => {
        const nextStatuses = res.data?.result;
        if (Array.isArray(nextStatuses) && nextStatuses.length > 0) {
          setPersonStatuses(nextStatuses);
        }
      })
      .catch(() => {});
  }, []);

  return personStatuses;
}
